import React from 'react';
import BillableCasesPage from './BillableCasesPage';

const BillingPage: React.FC = () => {
  return <BillableCasesPage />;
};

export default BillingPage; 